import React from 'react';
import { bool, func } from 'prop-types';
import { reduxForm } from 'redux-form';
import Radium from 'radium';
import { sameValue } from '@widergy/web-utils/lib/validate';
import { UTButton } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { CHANGE_PASSWORD_FORM } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';
import { passwordField } from 'constants/fields';

import styles from './styles';
import stylesCSS from './styles.module.scss';

const fields = [
  { ...passwordField, key: 'currentPassword', title: message('Configuration:typeCurrentPassword') },
  {
    ...passwordField,
    key: 'newPassword',
    title: message('Configuration:typeNewPassword'),
    validate: [
      ...passwordField.validate,
      sameValue('confirmNewPassword', message('Validations:passwordSameValue'))
    ]
  },
  {
    ...passwordField,
    key: 'confirmNewPassword',
    title: message('Configuration:confirmNewPassword'),
    validate: [...passwordField.validate, sameValue('newPassword', message('Validations:passwordSameValue'))]
  }
];

const ChangePasswordForm = ({ handleSubmit, submitFailed, invalid, onGoToDashboard }) => (
  <form onSubmit={handleSubmit} style={styles.container}>
    <div style={styles.content}>
      <UTForm fields={fields} />
      <div style={styles.actionButtonsContainer}>
        <UTButton secondary className={stylesCSS.cancelButton} onPress={onGoToDashboard}>
          {message('Commons:cancel')}
        </UTButton>
        <UTButton disabled={submitFailed && invalid} type="submit" className={stylesCSS.submitButton}>
          {message('Configuration:save')}
        </UTButton>
      </div>
    </div>
  </form>
);

ChangePasswordForm.propTypes = {
  handleSubmit: func.isRequired,
  submitFailed: bool,
  invalid: bool,
  onGoToDashboard: func
};

export default reduxForm({ form: CHANGE_PASSWORD_FORM })(Radium(ChangePasswordForm));
